<template>
<div class="title">
  <!-- 左側: 戻るボタン -->
  <div class="left" v-if="showBackButton">
    <button class="back-button" @click="$router.go(-1)">
      <img src="/img/back_icon.png" alt="back" />
    </button>
  </div>

  <!-- 中央: タイトル -->
  <span class="jpn">{{ jpn }}</span>

  <!-- 右側: ProductBanner -->
  <div class="right" v-if="packItem">
    <img class="product-banner" :src="packItem.image" />
  </div>
</div>
</template>

<script>

export default {
  props: {
    jpn: {
      type: String,
      default: '',
    },
    showBackButton: {
      type: Boolean,
      default: false, // デフォルトは非表示
    },
    packItem: {
      type: Object,
      default: null, // `null` の場合は `ProductBanner` を表示しない
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  position: relative;
  display: flex;
  height: auto; // 高さを自動調整
  justify-content: space-between;
  color: $gray2;
  font-size: 24px;
  font-weight: bold;
  align-items: flex-end;
  border-bottom: 1px solid $gray2;
}

.left {
  flex: 1;
  display: flex;
  align-items: flex-end;
  .back-button {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    img{
      width: 50px;
    }
  }
}

.right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
  width: auto;
  max-width: 200px; // 親が押し広げられないよう制限
  img{
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
    height: auto;
    max-width: 200px; // 親が押し広げられないよう制限
  }
}

.jpn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

@media screen and (max-width: $tabletWidth) {
  .title {
    height: 96px;
    font-size: 20px;
  }
  .left{
    .back-button {
    img{
      width: 40px;
    }
  }
  }
  .right{
    img{
      max-width: 150px; // 親が押し広げられないよう制限
    }
  }
}
@media screen and (max-width: 520px) {
  .title{
    height: 70px;
  }
  .right {
    img{
      max-width: 100px; // 親が押し広げられないよう制限
    }
  }
}

</style>
